export default "__VITE_ASSET__fdabb3f9__"